import { createTypes, actionCreator } from 'redux-action-creator';
import { parseJSON, handleNetworkError } from '../../utils'


export const paymentApplicationTypes = createTypes(['REQUEST', 'RECEIVE', 'ERROR', 'SUCCESS', 'ADD_EMPTY'], 'PAYMENT_APPLICATIONS');


export const requestPaymentApplications = () => {
    return {
        type: paymentApplicationTypes.REQUEST,
    };
};

export const receivePaymentApplications = (response) => {
    return {
        type: paymentApplicationTypes.RECEIVE,
        data: response,
    };
};

export const receivePaymentApplicationsError = (response) => {
    return {
        type: paymentApplicationTypes.ERROR,
        error: response,
    };
};

export const fetchPaymentApplications = (customerId) => {
    return dispatch => {
        const apiUrl = `/api/v1/paymentapplications/${customerId}/`

        dispatch(requestPaymentApplications());

        let headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        }

        return fetch(apiUrl, {
            headers: headers,
            credentials: 'include',
        })
        .then(parseJSON)
        .then(response => {
            try {
                dispatch(receivePaymentApplications(response));
            } catch (e) {
                dispatch(receivePaymentApplicationsError(response));
            }
        })
        .catch(handleNetworkError);
    };
};